import { CancelRegularPaymentsInClient } from "../../../../../../../../Wrap/Api/Payments/CancelRegularPaymentsIn";
import { CompletedProductPaymentsInClient } from "../../../../../../../../Wrap/Api/Payments/CompletedProductPaymentsIn";
import { PendingProductPaymentsInClient } from "../../../../../../../../Wrap/Api/Payments/PendingProductPaymentsIn";
import { ProductTransfersInClient } from "../../../../../../../../Wrap/Api/Transfer/ProductTransfersIn";
import { IJsonDate } from "../../../../../../../../Wrap/System/IJsonDate";

export class ProductOverviewPaymentsInAction {
    public static getTransferInDetail(hierarchyId: string, callback) {
        const client = new ProductTransfersInClient();
        const promise = client.get(hierarchyId);

        promise
            .onSuccess((data) => {
                callback(data);
            })
            .onError(() => {});
    }

    public static getPendingProductPaymentsIn(hierarchyId: string, callback) {
        const client = new PendingProductPaymentsInClient();
        const promise = client.get(hierarchyId);

        promise
            .onSuccess((data) => {
                callback(data);
            })
            .onError(() => {});
    }

    public static getComletedProductPaymentsIn(hierarchyId: string, date: IJsonDate, fromInception: boolean, callback) {
        const client = new CompletedProductPaymentsInClient();
        const promise = client.get(hierarchyId, date, fromInception);

        promise
            .onSuccess((data) => {
                callback(data);
            })
            .onError(() => {});
    }

    public static cancelRegularPaymentsIn(cashEntryId: number, hierarchyId: string, callback) {
        const client = new CancelRegularPaymentsInClient();
        const promise = client.post(cashEntryId, hierarchyId);

        promise
            .onSuccess((data) => {
                callback(data);
            })
            .onError(() => {});
    }
}
